import React from 'react';
import PropTypes from 'prop-types';

import Wrapper from './styled';

const SideBarBadge = ({
  label,
  compact,
  className
}) => {
  if (!label) return null;

  return (
    <Wrapper $compact={ compact } className={ className }>
      {label}
    </Wrapper>
  );
};

SideBarBadge.propTypes = {
  label: PropTypes.string,
  compact: PropTypes.bool,
  className: PropTypes.string
};

SideBarBadge.defaultProps = {
  label: '',
  compact: false,
  className: ''
};

export default SideBarBadge;
